import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false, //   <---- this will do the magic
    },
    fallbackLng: 'en',
    // debug: true,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
